import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	stepLocatorNonFinal: {
		id: 'eoc-changeboarding.common.wizard.layout.step-locator-non-final',
		defaultMessage: 'Step {currentStep} of 4',
		description: 'Indicator of current step',
	},
	nextButtonNonFinal: {
		id: 'eoc-changeboarding.common.wizard.layout.next-button-non-final',
		defaultMessage: 'Next',
		description: 'Next button label',
	},
	backButtonNonFinal: {
		id: 'eoc-changeboarding.common.wizard.layout.back-button-non-final',
		defaultMessage: 'Back',
		description: 'Back button label',
	},
	closeButtonNonFinal: {
		id: 'eoc-changeboarding.common.wizard.layout.close-button-non-final',
		defaultMessage: 'Close',
		description: 'Close button label',
	},
	openShiftingGuideButtonNonFinal: {
		id: 'eoc-changeboarding.common.wizard.layout.open-shifting-guide-button-non-final',
		defaultMessage: 'Open guide',
		description: 'Open shifting guide button label',
	},
	remindMeLaterButtonNonFinal: {
		id: 'eoc-changeboarding.common.wizard.layout.remind-me-later-button-non-final',
		defaultMessage: 'Remind me later',
		description: 'Remind me later button label',
	},
});
